import React from "react";
import BuyerUsername from "./BuyerUsername";
import ShopType from "@/enum/ShopType";
import OrderDTO from "@/dto/order/OrderDTO";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { observer } from "mobx-react-lite";
import { useGlobalStore } from "@/store/hooks";
import { hasBuyerNickname } from "@/utils/ShopUtils";

interface BuyerUsernameColumnProps {
    order: OrderDTO;
    shopType: ShopType;
}

const BuyerUsernameColumn: React.FC<BuyerUsernameColumnProps> = observer((props) => {
    const { order } = props;

    const store = useOrderManagementStore();
    const { shopMapping } = useGlobalStore();

    function handleSearchByName() {
        const shopType = shopMapping.get(order.shopId)?.type;

        let name = order.buyerUsername;

        if (hasBuyerNickname(shopType)) {
            name = order.buyerNickname;
        }

        store.table.resetFormValues(["shopIds"]);
        store.table.form.setFieldsValue({ buyerUsername: name });
        store.table.changePageNo(1);
        store.fetchOrders(order.shopId);
    }

    return (
        <td>
            <BuyerUsername {...props} onSearch={handleSearchByName} />
        </td>
    );
});

export default BuyerUsernameColumn;
